class FacetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 500);

        const facetForm = this.querySelector("form");
        facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

        const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
        if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

        this.customFilters = debounce((event) => {
            const filterLinkElement = event.target.closest(".filter-link");
            const multiStepElement = event.target.closest(".filter-multi-step");

            if (!filterLinkElement || (event.defaultPrevented && multiStepElement)) return;

            event.preventDefault();
            event.stopPropagation();

            let data_filter = filterLinkElement.getAttribute("data-filter");
            let data_type = filterLinkElement.getAttribute("data-type");

            if (!data_filter || !data_type) {
                const childWithFilter = filterLinkElement.querySelector("[data-filter]");
                const childWithType = filterLinkElement.querySelector("[data-type]");

                data_filter = childWithFilter ? childWithFilter.getAttribute("data-filter") : null;
                data_type = childWithType ? childWithType.getAttribute("data-type") : null;
            }

            if (data_filter && data_type) {
                let searchParams = `${data_type}=${data_filter}`;
                if (multiStepElement) {
                    const params = new URLSearchParams(window.location.search);
                    params.set(data_type, data_filter);
                    searchParams = params.toString();
                }
                FacetFiltersForm.renderPage(searchParams, null, true);
                document.getElementById(`Slider-${multistepID}`).scrollLeft = 0;
            }
        }, 500);

        document.addEventListener("click", this.customFilters.bind(this));
    }

    static isSizeFilterParam(paramName) {
        if (!paramName) return false;
        const normalizedParam = paramName.toLowerCase();
        if (normalizedParam === "filter.v.option.size") return true;
        if (!normalizedParam.startsWith("filter.v.option.")) return false;
        return normalizedParam.split(".").pop() === "size";
    }

    static normalizeSearchParams(searchParams) {
        const params = new URLSearchParams(searchParams || "");
        if (!window.location.pathname.includes("/collections/")) {
            return params.toString();
        }
        let hasActiveSizeFilter = false;

        for (const [name, value] of params.entries()) {
            if (FacetFiltersForm.isSizeFilterParam(name) && value) {
                hasActiveSizeFilter = true;
                break;
            }
        }

        if (hasActiveSizeFilter) {
            params.set("filter.v.availability", "1");
        } else {
            params.delete("filter.v.availability");
        }

        return params.toString();
    }

    static setListeners() {
        const normalizedSearchParams = FacetFiltersForm.normalizeSearchParams(
            FacetFiltersForm.searchParamsInitial
        );

        if (normalizedSearchParams !== FacetFiltersForm.searchParamsInitial) {
            FacetFiltersForm.searchParamsInitial = normalizedSearchParams;
            FacetFiltersForm.searchParamsPrev = normalizedSearchParams;
            FacetFiltersForm.renderPage(normalizedSearchParams, null, true);
        }

        const onHistoryChange = (event) => {
            const searchParamsRaw = event.state
                ? event.state.searchParams
                : FacetFiltersForm.searchParamsInitial;
            const searchParams = FacetFiltersForm.normalizeSearchParams(searchParamsRaw);
            if (searchParams === FacetFiltersForm.searchParamsPrev) return;
            FacetFiltersForm.renderPage(searchParams, null, false);
        };
        window.addEventListener("popstate", onHistoryChange);

        FacetFiltersForm.cleanupEmptyProductCards(document);

        if (typeof multistepOrder !== "undefined") {
            const searchParams = FacetFiltersForm.searchParamsInitial;
            FacetFiltersForm.getMultiStepFromFetch(searchParams);
        }
    }

    static getMultiStepFromFetch(searchParams) {
        const url = `${window.location.pathname}?${searchParams}`;
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;
                const parsedHTML = new DOMParser().parseFromString(html, "text/html");
                FacetFiltersForm.renderActiveFacets(parsedHTML);
                const facetDetailsElements = parsedHTML.querySelectorAll(
                    "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
                );
                const matchesIndex = (element) => {
                    const jsFilter = event ? event.target.closest(".js-filter") : undefined;
                    return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
                };
                const facetsToRender = Array.from(facetDetailsElements).filter(
                    (element) => !matchesIndex(element)
                );

                facetsToRender.forEach((element) => {
                    setMultiStepFilter(element, true);
                });
                const multistepOrderMap = new Map(
                    multistepOrder.map((item, index) => [item, index])
                );
                multistepFilter.sort((a, b) => {
                    const indexA = multistepOrderMap.get(a.name);
                    const indexB = multistepOrderMap.get(b.name);
                    return indexA - indexB;
                });

                renderMultiStepFilter(multistepID, multistepFilter);
            });
    }

    static toggleActiveFacets(disable = true) {
        document.querySelectorAll(".js-facet-remove").forEach((element) => {
            element.classList.toggle("disabled", disable);
        });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
        searchParams = FacetFiltersForm.normalizeSearchParams(searchParams);
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();
        const countContainer = document.getElementById("ProductCount");
        const countContainerDesktop = document.getElementById("ProductCountDesktop");
        document
            .getElementById("ProductGridContainer")
            .querySelector(".collection")
            .classList.add("loading");
        if (countContainer) {
            countContainer.classList.add("loading");
        }
        if (countContainerDesktop) {
            countContainerDesktop.classList.add("loading");
        }

        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = (element) => element.url === url;

            FacetFiltersForm.filterData.some(filterDataUrl)
                ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
                : FacetFiltersForm.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event) {
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;
                FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
                FacetFiltersForm.renderFilters(html, event);
                FacetFiltersForm.renderProductGridContainer(html);
                FacetFiltersForm.renderProductCount(html);
            });
    }

    static renderSectionFromCache(filterDataUrl, event) {
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
    }

    static renderProductGridContainer(html) {
        document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
            .parseFromString(html, "text/html")
            .getElementById("ProductGridContainer").innerHTML;
        let buttonGrid = document.getElementById("buttonGrid");
        let productGrid = document.getElementsByClassName("product-grid");
        let buttonGridImage = document.getElementById("buttonGridImage");
        let gridImages = document.getElementsByClassName("grid__item");
        let counterMobile = document
            .getElementById("facet-clear-mobile")
            .innerHTML.replace(/[()]/g, "");
        let intCounter = parseInt(counterMobile);

        if (buttonGrid.classList.contains("active")) {
            for (var x = 0; x < productGrid.length; x++) {
                if (productGrid[x].classList.contains("grid--1-col-tablet-down")) {
                    productGrid[x].classList.remove("grid--1-col-tablet-down");
                    productGrid[x].classList.add("grid--2-col-tablet-down");
                }
            }
        }

        if (intCounter > 0) {
            for (var x = 0; x < productGrid.length; x++) {
                if (!productGrid[x].classList.contains("filters-open")) {
                    productGrid[x].classList.add("filters-open");
                }
            }
        } else {
            for (var x = 0; x < productGrid.length; x++) {
                if (productGrid[x].classList.contains("filters-open")) {
                    productGrid[x].classList.remove("filters-open");
                }
            }
        }

        if (buttonGridImage.classList.contains("active")) {
            for (var x = 0; x < gridImages.length; x++) {
                if (gridImages[x].classList.contains("primary__image")) {
                    gridImages[x].classList.add("hidden");
                }

                if (gridImages[x].classList.contains("secondary__image")) {
                    gridImages[x].classList.remove("hidden");
                }
            }
        }

        let allColors = document.querySelectorAll(".colorlist label");

        var getData = function () {
            var parent =
                this.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
            var get_selector = parent.getAttribute("data-selector");
            var get_color = this.getAttribute("data-opt-color");
            var handle = parent.getAttribute("data-product-handle");
            var limit = parent.getAttribute("data-id");

            let size_selector = document.querySelector(
                '[data-selector="' +
                    get_selector +
                    '"][data-product-handle="' +
                    handle +
                    '"][data-id="' +
                    limit +
                    '"] [data-color-sizes="' +
                    get_color +
                    '"]'
            );

            var actives = parent.querySelectorAll(".active");
            [].forEach.call(actives, function (elem) {
                elem.classList.remove("active");
            });

            if (size_selector) size_selector.classList.add("active");
            const priceSelector = document
                .querySelector(
                    '[data-selector="' +
                        get_selector +
                        '"][data-product-handle="' +
                        handle +
                        '"][data-id="' +
                        limit +
                        '"] [data-color-price="' +
                        get_color +
                        '"]'
                );
            if (priceSelector) priceSelector.classList.add("active");
            const titleSelector = document.querySelector(
                '[data-selector="' +
                    get_selector +
                    '"][data-product-handle="' +
                    handle +
                    '"][data-id="' +
                    limit +
                    '"] [data-color-title="' +
                    get_color +
                    '"]'
            );
            if (titleSelector) titleSelector.classList.add("active");
            const imageSelector = document.querySelector(
                '[data-selector="' +
                    get_selector +
                    '"][data-product-handle="' +
                    handle +
                    '"][data-id="' +
                    limit +
                    '"] [data-color-imgs="' +
                    get_color +
                    '"]'
            );
            if (imageSelector) imageSelector.classList.add("active");

            const selectedVariantId =
                (priceSelector && priceSelector.getAttribute("data_id")) ||
                this.getAttribute("data-opt-id");
            const relatedSelectors = [get_selector];
            if (get_selector.indexOf("pcpsecondary-") === 0) {
                relatedSelectors.push(get_selector.replace("pcpsecondary-", "pcp-"));
            } else if (get_selector.indexOf("pcp-") === 0) {
                relatedSelectors.push(get_selector.replace("pcp-", "pcpsecondary-"));
            }
            relatedSelectors.forEach((selectorName) => {
                const selectorRoot =
                    '[data-selector="' +
                    selectorName +
                    '"][data-product-handle="' +
                    handle +
                    '"][data-id="' +
                    limit +
                    '"]';
                const cardLink = document.querySelector(selectorRoot + " a.sizelist-wrap");
                if (cardLink && selectedVariantId) {
                    const nextUrl = new URL(
                        cardLink.getAttribute("href"),
                        window.location.origin
                    );
                    nextUrl.searchParams.set("variant", selectedVariantId);
                    cardLink.setAttribute(
                        "href",
                        `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`
                    );
                }
                const scopedImageLink = document.querySelector(
                    selectorRoot +
                        ' [data-color-imgs="' +
                        get_color +
                        '"] .grid-product__image-link'
                );
                if (scopedImageLink && selectedVariantId) {
                    const nextImageUrl = new URL(
                        scopedImageLink.getAttribute("href"),
                        window.location.origin
                    );
                    nextImageUrl.searchParams.set("variant", selectedVariantId);
                    scopedImageLink.setAttribute(
                        "href",
                        `${nextImageUrl.pathname}${nextImageUrl.search}${nextImageUrl.hash}`
                    );
                }
            });

            const selectedColorInput = document.querySelector(
                '[data-selector="' +
                    get_selector +
                    '"][data-product-handle="' +
                    handle +
                    '"][data-id="' +
                    limit +
                    '"] [data-opt-color-selected="1"]'
            );
            if (selectedColorInput)
                selectedColorInput.setAttribute("data-opt-color-selected", "0");

            this.setAttribute("data-opt-color-selected", "1");
        };
        for (var i = 0; i < allColors.length; i++) {
            allColors[i].addEventListener("click", getData, false);
        }

        FacetFiltersForm.cleanupEmptyProductCards(document);
    }

    static cleanupEmptyProductCards(scope = document) {
        const grid = scope.querySelector("#product-grid");
        if (!grid) return;

        const gridItems = grid.querySelectorAll("li.grid__item");
        gridItems.forEach((item) => {
            if (item.classList.contains("banner__item")) return;

            const hasCard = item.querySelector(".custom-product-card");
            if (!hasCard) return;

            const hasImage = item.querySelector(".grid-product__image-wrapper");
            const hasTitle = item.querySelector(".grid-product__meta");
            const hasPrice = item.querySelector(".grid-product__price-wrap");

            if (!hasImage && !hasTitle && !hasPrice) {
                item.remove();
            }
        });
    }

    static renderProductCount(html) {
        const count = new DOMParser()
            .parseFromString(html, "text/html")
            .getElementById("ProductCount").innerHTML;
        const container = document.getElementById("ProductCount");
        const containerDesktop = document.getElementById("ProductCountDesktop");
        container.innerHTML = '<span style="color:red;">' + count + "</span>";
        const aux = count.split(" ");
        container.classList.remove("loading");
        if (containerDesktop) {
            containerDesktop.innerHTML = `<span style="color:red;">${aux[0]}</span> ${aux
                .slice(1)
                .join(" ")}`;
            containerDesktop.classList.remove("loading");
        }
    }

    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");

        const facetDetailsElements = parsedHTML.querySelectorAll(
            "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
        );
        const matchesIndex = (element) => {
            const jsFilter = event ? event.target.closest(".js-filter") : undefined;
            return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        };
        const facetsToRender = Array.from(facetDetailsElements).filter(
            (element) => !matchesIndex(element)
        );
        const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

        facetsToRender.forEach((element) => {
            document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML =
                element.innerHTML;
            if (typeof multistepOrder !== "undefined") setMultiStepFilter(element);
        });

        if (typeof multistepOrder !== "undefined")
            renderMultiStepFilter(multistepID, multistepFilter);

        FacetFiltersForm.renderActiveFacets(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender)
            FacetFiltersForm.renderCounts(countsToRender, event.target.closest(".js-filter"));
        document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
            summary.setAttribute("role", "button");
            summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

            if (summary.nextElementSibling.getAttribute("id")) {
                summary.setAttribute("aria-controls", summary.nextElementSibling.id);
            }

            summary.addEventListener("click", (event) => {
                if (event.currentTarget.classList.contains("link--child")) {
                    closeAll(event);
                } else {
                    event.currentTarget.setAttribute(
                        "aria-expanded",
                        !event.currentTarget.closest("details").hasAttribute("open")
                    );
                }
            });

            if (summary.closest("header-drawer")) return;
            summary.parentElement.addEventListener("keyup", onKeyUpEscape);
        });

        function closeAll(e) {
            document.querySelectorAll('[id^="Details-"] summary.link--child').forEach((summary) => {
                if (e.currentTarget === summary) {
                    e.currentTarget.setAttribute(
                        "aria-expanded",
                        !e.currentTarget.closest("details").hasAttribute("open")
                    );
                    if (summary.classList.contains("accordion--child")) {
                        summary.parentNode.scrollIntoView({ behavior: "smooth" });
                    }
                } else {
                    summary.setAttribute("aria-expanded", false);
                    summary.parentNode.removeAttribute("open");
                }
            });
        }
    }

    static renderActiveFacets(html) {
        const activeFacetElementSelectors = [".active-facets-mobile", ".active-facets-desktop"];

        activeFacetElementSelectors.forEach((selector) => {
            const activeFacetsElement = html.querySelector(selector);
            if (!activeFacetsElement) return;

            let filters = Array.from(activeFacetsElement.children);

            if (typeof multistepOrder !== "undefined" && Array.isArray(multistepOrder)) {
                filters.sort((a, b) => {
                    const getKey = (element) => {
                        const textContent = element.textContent.toLowerCase();
                        return multistepOrder.findIndex((key) => textContent.includes(key));
                    };

                    return getKey(a) - getKey(b);
                });
            }

            const targetElement = document.querySelector(selector);
            targetElement.style.visibility = "visible";
            targetElement.innerHTML = "";
            filters.forEach((filter) => targetElement.appendChild(filter));
            let newFilters = filters

            let lastFilter = newFilters.findLast((element) => element.localName == "facet-remove")
            
            if(newFilters.length == 0){
                if(document.getElementById("remove-filter")){
                    document.getElementById("remove-filter").style.visibility = "hidden";
                }
            }

            if(lastFilter){
                if(document.getElementById("remove-filter")){
                    document.getElementById("remove-filter").setAttribute("href",lastFilter.querySelector('a').getAttribute("href"))
                    document.getElementById("remove-filter").style.visibility = "visible";
                }
            }
        });

        FacetFiltersForm.toggleActiveFacets(false);
    }

    static renderAdditionalElements(html) {
        const mobileElementSelectors = [
            ".mobile-facets__open",
            ".mobile-facets__count",
            ".sorting",
        ];

        mobileElementSelectors.forEach((selector) => {
            if (!html.querySelector(selector)) return;
            document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
        });

        //document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents();
    }

    static renderCounts(source, target) {
        if (typeof multistepOrder !== "undefined") setMultiStepFilter(source, true);
        const targetElement = target.querySelector(".facets__selected");
        const sourceElement = source.querySelector(".facets__selected");

        const targetElementAccessibility = target.querySelector(".facets__summary");
        const sourceElementAccessibility = source.querySelector(".facets__summary");

        if (sourceElement && targetElement) {
            target.querySelector(".facets__selected").outerHTML =
                source.querySelector(".facets__selected").outerHTML;
        }

        if (targetElementAccessibility && sourceElementAccessibility) {
            target.querySelector(".facets__summary").outerHTML =
                source.querySelector(".facets__summary").outerHTML;
        }
        const counter = document.querySelectorAll(".facet-count");
        let c = 0;
        for (let index = 0; index < counter.length; index++) {
            c = c + parseInt(counter[index].innerHTML);
        }
        document.getElementById("facet-clear").innerHTML = c;
        document.getElementById("facet-clear-mobile").innerHTML = "(" + c + ")";
    }

    static updateURLHash(searchParams) {
        history.pushState(
            { searchParams },
            "",
            `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
        );
    }

    static getSections() {
        return [
            {
                section: document.getElementById("product-grid").dataset.id,
            },
        ];
    }

    createSearchParams(form) {
        const formData = new FormData(form);
        return new URLSearchParams(formData).toString();
    }

    onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll("facet-filters-form form");
        if (event.srcElement.className == "mobile-facets__checkbox") {
            const searchParams = this.createSearchParams(event.target.closest("form"));
            this.onSubmitForm(searchParams, event);
        } else {
            const forms = [];
            const isMobile = event.target.closest("form").id === "FacetFiltersFormMobile";

            sortFilterForms.forEach((form) => {
                if (!isMobile) {
                    if (
                        form.id === "FacetSortForm" ||
                        form.id === "FacetFiltersForm" ||
                        form.id === "FacetSortDrawerForm"
                    ) {
                        const noJsElements = document.querySelectorAll(".no-js-list");
                        noJsElements.forEach((el) => el.remove());
                        forms.push(this.createSearchParams(form));
                    }
                } else if (form.id === "FacetFiltersFormMobile") {
                    forms.push(this.createSearchParams(form));
                }
            });
            this.onSubmitForm(forms.join("&"), event);
        }
    }

    onActiveFilterClick(event) {
        let counterMobile = document
            .getElementById("facet-clear-mobile")
            .innerHTML.replace(/[()]/g, "");

        let qty = document.getElementById("facet-clear");
        let intCounter = parseInt(counterMobile);
        if (intCounter >= 0) {
            intCounter = intCounter - 1;
            document.getElementById("facet-clear").innerHTML = intCounter;
            document.getElementById("facet-clear-mobile").innerHTML = "(" + intCounter + ")";
        }
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url =
            event.currentTarget.href.indexOf("?") == -1
                ? ""
                : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
        FacetFiltersForm.renderPage(url);
    }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();
window.cleanupCollectionEmptyCards = (scope = document) =>
    FacetFiltersForm.cleanupEmptyProductCards(scope);

class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll("input").forEach((element) =>
            element.addEventListener("change", this.onRangeChange.bind(this))
        );
        this.setMinAndMaxValues();
    }

    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }

    setMinAndMaxValues() {
        const inputs = this.querySelectorAll("input");
        const minInput = inputs[0];
        const maxInput = inputs[1];
        if (maxInput.value) minInput.setAttribute("max", maxInput.value);
        if (minInput.value) maxInput.setAttribute("min", minInput.value);
        if (minInput.value === "") maxInput.setAttribute("min", 0);
        if (maxInput.value === "") minInput.setAttribute("max", maxInput.getAttribute("max"));
    }

    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute("min"));
        const max = Number(input.getAttribute("max"));

        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector("a");
        facetLink.setAttribute("role", "button");
        facetLink.addEventListener("click", this.closeFilter.bind(this));
        facetLink.addEventListener("keyup", (event) => {
            event.preventDefault();
            if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
        });
    }

    closeFilter(event) {
        event.preventDefault();
        const form =
            this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
        form.onActiveFilterClick(event);
    }
}

customElements.define("facet-remove", FacetRemove);

function setMultiStepFilter(element, initial = false) {
    const name = element.querySelector("summary").dataset.name.split(".").pop();
    if (multistepOrder.includes(name)) {
        const activeValues = parseInt(element.querySelector(".facets__selected").innerHTML);
        const list = Array.from(
            element.querySelectorAll(".list-unstyled.no-js-hidden .list-menu__item.facets__item")
        );
        const values = list.map((value) => {
            const input = value.querySelector("input");
            return {
                disabled: input.disabled,
                title: value.querySelector("span").innerHTML,
                image: input.dataset.image,
                mobileImage: input.dataset.imageMobile,
            };
        });
        const option = {
            name: element.querySelector("summary").dataset.name.split(".").pop(),
            values: values,
            active: activeValues,
        };

        if (initial) {
            multistepFilter.push(option);
        } else {
            const index = multistepFilter.findIndex((obj) => obj.name === option.name);
            if (index !== -1) multistepFilter[index] = { ...multistepFilter[index], ...option };
        }
    }
}

function renderMultiStepFilter(sectionID, filters) {
    const indexFilter = filters.findIndex((filter) => filter.active === 0);
    const option = filters[indexFilter];
    console.log("indexFilter", indexFilter);
    const section = document.getElementById(`Slider-${sectionID}`);
    if (!section) return;
    section.innerHTML = "";
    if (indexFilter === -1) return;
    let html = "";
    if (option.values.length > 0) {
        option.values.forEach((filter) => {
            if (filter.disabled) return;
            let desktopImage = "";
            let mobileImage = "";

            if (filter.image) {
                desktopImage = `
                <div class="collection-filter-item-image collection-carousel-item-image-desktop">
                    <img src="${filter.image}" width="1030" height="750.0" class="collection-filter-item-image-img ${multistepOverlayClass}" alt="Filter ${filter.title}"/>
                </div>
                `;
            }
            if (filter.mobileImage || filter.image) {
                mobileImage = `
                <div class="collection-filter-item-image collection-carousel-item-image-mobile">
                    <img src="${
                        filter.mobileImage || filter.image
                    }" width="1030" height="750.0" class="collection-filter-item-image-img ${multistepOverlayClass}" alt="Filter ${
                    filter.title
                }"/>
                </div>
                `;
            }
            html += `
        <div
            class="collection-filter-item custom-collection-filter-item slider__slide slider__slide--full-width article pcp-custom-collection-carousel-item filter-link filter-multi-step"
            id="Slide-${sectionID}-${option.name}"
        >
            ${desktopImage}
            ${mobileImage}
            <div
                data-type="filter.p.m.custom.${option.name}"
                data-filter="${filter.title}"
                class="collection-filter-item-content ${multistepFiltersClass}"
            >
                <div class="${multistepInnerClass}">
                    <p class="collection-filter-heading ${multistepHeadingClass}">
                        ${filter.title}
                    </p>
                </div>
            </div>
        </div>
        `;
        });
    }
    section.innerHTML = html;
}
